import { initTranslation } from "../modules/i18n";
import initPage from "../modules/page";
import initDepartments from "../modules/departments.js";
import { initCarousels } from "../modules/product-collection";
import "../../scss/error.scss";

async function initErrorPage() {
  await initTranslation();
  initDepartments();
  initPage();
  initCarousels();
}

initErrorPage();
